module.exports = __webpack_public_path__ + "img/IMG_1962_P_L_BlackMatted_MockedUp.418f9829.jpg";